import { FC } from "react";
import { components, ControlProps, GroupBase } from "react-select";
import SelectCarma from "../../../Select/Select";
import { ArrawDownIcon } from "../../../icons";
import { ISelectBrandsProps } from "./types";
import { ISelectCarmaOption } from "../../../Select/types";
import styles from "./SelectBrands.module.css";



const CustomControl = (props: ControlProps<ISelectCarmaOption, boolean, GroupBase<ISelectCarmaOption>>) => {
  return (
    <components.Control {...props}>
      <div className={styles["select-brands__control"]}>
        <ArrawDownIcon />
        {props.children}
      </div>
    </components.Control>
  );
};

const SelectBrands: FC<ISelectBrandsProps> = ({ brands, onChangeBrand }) => {
  const options = brands.map((brand) => ({
    id: brand.id,
    label: brand.name,
    value: brand.id,
  }));

  return <div className={styles['select-brands']}>
    <SelectCarma
      options={options}
      components={{
        Control: CustomControl,
        IndicatorsContainer: () => null,
        ValueContainer: (props) => (
          <components.ValueContainer {...props}></components.ValueContainer>
        ),
      }}
      onChange={(newValue) => {
        if (newValue && typeof newValue === 'object' && 'id' in newValue) {
          const brand = brands.find((brand) => brand.id === newValue.id);

          if (brand) {
            onChangeBrand(brand);
          }
        }
      }}
    />
  </div>;
};

export default SelectBrands;
